import { fetchHotelOfferSales } from 'actions/OfferActions'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from './reduxHooks'
import { CUSTOMER_TYPES } from 'constants/search'

function useHotelOfferSales(
  offerOrPropertyId: string,
  customerType: CUSTOMER_TYPES,
): [number, boolean] {
  const dispatch = useAppDispatch()

  useEffect(() => { dispatch(fetchHotelOfferSales(offerOrPropertyId, 30)) }, [dispatch, offerOrPropertyId])

  const count = useAppSelector(state => state.offer.hotelSales[offerOrPropertyId]?.[customerType])

  const fetching = useAppSelector(state => !state.offer.hotelSales[offerOrPropertyId]?.[customerType])

  return [count, fetching]
}

export default useHotelOfferSales
